module.exports = __webpack_public_path__ + "img/signup.9a53839b.jpg";